import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {

    setItem(itemName: string, value: any): void {
        localStorage.setItem('cockpit_' + itemName, JSON.stringify(value));
    }

    getItem(itemName: string): any {
        if (localStorage.getItem('cockpit_' + itemName)) {
            const item = localStorage.getItem('cockpit_' + itemName);
            return item ? JSON.parse(item) : null;
        } else {
            return null;
        }
    }

    removeItem(itemName: string): void {
        localStorage.removeItem('cockpit_' + itemName);
    }
}
